export default {
  ...JSON.parse(JSON.stringify(process)).env,
}
